<!--
 * @Author: xuquantong
 * @Date: 2022-04-27 11:30:02
 * @LastEditors: tianyuhan
 * @LastEditTime: 2023-08-01 11:47:04
 * @Description: 更多参数
-->
<template>
  <div
    class="product-info-more-param border1px"
    v-if="skuInfo && skuInfo.specImgUrl"
    v-track="{
      act: 'show',
      params: {
        cfrom: '175|001|02|077',
        event_id: '175|001|02|077',
        page_name: 1,
        sku_id: skuId
      }
    }"
  >
    <div :class="['specif-box', isShowPK ? 'mr108' : '']">
      <div class="left">参数</div>
      <div class="scroll-img" @click="showPopup" tabindex="0">
        <img v-if="isDark && skuInfo.darkSpecImgUrl" v-lazy="skuInfo.darkSpecImgUrl" alt="手机参数图" />
        <img v-else-if="skuInfo.specImgUrl" v-lazy="skuInfo.specImgUrl" alt="手机参数图" />
      </div>
      <template v-if="isShowPK">
        <div class="shadow"></div>
        <div
          class="more"
          @click="goCompare()"
          v-track="trackData.baseInfoClick({ sku_id: skuId, info_content: 9 })"
          tabindex="0"
          aria-label="机型对比"
        >
          <v-icon class="icon-pk" name="icon-pk" aria-hidden="true"></v-icon>
          <div class="word" aria-hidden="true">机型</div>
          <div class="word" aria-hidden="true">对比</div>
        </div>
      </template>
    </div>
    <portal to="more-parameter-popup">
      <v-os-popup
        :lazyRender="true"
        title="产品参数"
        v-model="showParams"
        @close="showParams = false"
        :maxHeightFill="true"
        :footerShow="false"
        class="paramspopup"
        style="z-index: 3000"
        container="body"
      >
        <SpecPopup></SpecPopup>
      </v-os-popup>
    </portal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SpecPopup from '../../spec-popup'
import { app } from '@/utils'
import trackData from '../trackData'

export default {
  name: 'MoreParameter',
  components: {
    SpecPopup
  },
  computed: {
    ...mapState('detailv3', ['skuInfo']),
    ...mapGetters('detailv3', ['spuId', 'skuId', 'isShowPK'])
  },
  data() {
    return {
      trackData,
      showParams: false,
      isDark: app.getColorScheme()
    }
  },
  methods: {
    showPopup() {
      if (this.skuInfo.parameters && this.skuInfo.parameters.length > 0) {
        this.showParams = true
      }
      this.$track({
        cfrom: '175|001|01|077',
        event_id: '175|001|01|077',
        page_name: 1,
        sku_id: this.skuId
      })
    },
    goCompare() {
      app.openNewWebview({
        url: `${this.linkBase}/compare?spuId=${this.spuId}&skuId=${this.skuId}`
      })
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped src="../../../index/dark-popup.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4 {
  .specif-box.mr108 .scroll-img img {
    height: 212px;
  }
}
.vivo-fontscale-5 {
  .specif-box.mr108 .scroll-img img {
    height: 232px;
  }
}
</style>
